import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import { SyncOutlined } from '@ant-design/icons';
import * as Map from 'immutable';
import './index.scss';

const MIN_RETRY_COUNT = 6;

class index extends Component {
  //验证是否更新
  shouldComponentUpdate(newProps, newState) {
    if (
      Map.is(
        Map.fromJS(this.props.base.nimConnState),
        Map.fromJS(newProps.base.nimConnState)
      )
    ) {
      return false;
    }
    return true;
  }
  render() {
    const { base } = this.props;
    if (!base.nimConnState) return null;
    if (base?.nimConnState?.retryCount < MIN_RETRY_COUNT) return null;
    const { retryCount } = base.nimConnState;
    return (
      <div className="nimConnState-loading animated fadeInDown">
        <div className="bg">
          <div className="errt">网络出现问题啦，快去检查一下吧~</div>
          <div className="dms">
            <SyncOutlined spin />
            <p>正在尝试{retryCount - MIN_RETRY_COUNT + 1}/10次重新连接...</p>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(index, { withRef: true })
);
